import { IComplaintTrackingRow } from 'types/ComplaintTracking';
import { ThunkApiType } from 'types/utils';
import authFetch, { checkForUnauthorizedResponse } from 'utils/axios';
import { exportListToExcel } from 'utils/download';
import {
	buildComplaintFilterParams,
	buildFraudFilterParams,
} from 'utils/utils';

export const getFraudTrackingThunk = async (
	_: void,
	thunkAPI: ThunkApiType,
) => {
	const { page } = thunkAPI.getState().fraudTracking;
	const { queryParams } = buildFraudFilterParams(thunkAPI.getState().form);
	const { sortingFields, sortingDirections } = thunkAPI.getState().form;

	const getFraudTrackingURL =
		`/frauds/tracking` +
		`?page=${page}&sortingFields=${sortingFields}&sortingDirections=${sortingDirections}${
			queryParams ? queryParams : ''
		}`;

	try {
		const response = await authFetch.get(getFraudTrackingURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const getFraudTrackingDetailThunk = async (
	{ uuid, id }: { uuid?: string; id?: string },
	thunkAPI: ThunkApiType,
) => {
	const getFraudDetailURL = uuid ? `/frauds/claims/${uuid}` : `/frauds/${id}`;

	try {
		const response = await authFetch.get(getFraudDetailURL);
		return response.data;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const saveFraudThunk = async (_: {}, thunkAPI: ThunkApiType) => {
	const { fraudDetail } = thunkAPI.getState().fraudTracking;
	try {
		if (!fraudDetail.fraudId) {
			const response = await authFetch.post(`/frauds`, fraudDetail);
			return response.data;
		} else {
			const response = await authFetch.put(`/frauds`, fraudDetail);
			return response.data;
		}
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};

export const downloadFraudTrackingThunk = async (
	{ uuid, type }: { uuid?: string; type: 'PDF' | 'XLSX' },
	thunkAPI: ThunkApiType,
) => {
	let getDownloadClaimIdURL = '/fraud/downloadFraudDetail';
	let getDownloadClaimsListURL = `/fraud/downloadFraudList`;

	const { downloadAll, selectedItems } = thunkAPI.getState().tableSelectedItems;

	if (uuid) {
		getDownloadClaimIdURL = getDownloadClaimIdURL + `?claimUuid=${uuid}`;
		try {
			const response = await authFetch.get(getDownloadClaimIdURL, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claim', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	} else {
		const { sortingFields, sortingDirections } = thunkAPI.getState().form;
		const { body: filterBody } = buildComplaintFilterParams(
			thunkAPI.getState().form,
		);

		const sortField = sortingFields || 'serviceDate,externalClaimId';
		const sortDirection = sortingDirections || 'DESC,DESC';

		const values = {
			...filterBody,
			format: type,
			fraudIds: downloadAll
				? []
				: selectedItems.map((el: IComplaintTrackingRow) => el),
			excludeUuids: !downloadAll
				? selectedItems.map((el: IComplaintTrackingRow) => el)
				: [],
			sortingFields: sortField,
			sortingDirections: sortDirection,
		};

		try {
			const response = await authFetch.post(getDownloadClaimsListURL, values, {
				responseType: 'blob',
			});
			exportListToExcel(response.data, 'Claims', type);
			return true;
		} catch (error: ThunkApiType) {
			return checkForUnauthorizedResponse(error, thunkAPI);
		}
	}
};
